<template>
  <v-form @submit.stop.prevent="submitContactForm">
    <v-layout row wrap fill-height>
      <v-flex xs12>
        <h1>Kontaktskjema</h1>
      </v-flex>
      <v-flex xs12 sm7 class="pr-3">
        <v-textarea box height="250px" label="Beskjed" v-model="message"></v-textarea>
      </v-flex>
      <v-flex xs12 sm5>
        <v-layout align-space-between justify-space-between column fill-height>
          <v-flex d-flex>
            <v-text-field v-model="name" style="margin-top: auto; margin-bottom:0" label="Navn"></v-text-field>
          </v-flex>
          <v-flex d-flex>
            <v-text-field
              v-model="email"
              style="margin-top: auto; margin-bottom:0"
              type="email"
              label="E-post"
            ></v-text-field>
          </v-flex>
          <v-flex d-flex>
            <v-text-field
              v-model="phone"
              style="margin-top: auto; margin-bottom:0"
              type="number"
              label="Telefon"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn type="submit">{{ $t("send") }}</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      message: "",
      name: "",
      email: "",
      phone: ""
    };
  },
  methods: {
    submitContactForm() {
      let _ContactForm = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        message: this.message
      };
      // eslint-disable-next-line no-console
      axios
        .post("https://followup.dev.prios.no/api/crm/contactform", _ContactForm)
        .then(() => {
          // commit("changeState", "updated");
          alert("Beskjed er sendt");
          this.name = "";
          this.email = "";
          this.phone = "";
          this.message = "";
        });
    }
  }
  // mounted(){
  //
  // },
};
</script>

<style scoped>
</style>
